module.exports = __webpack_public_path__ + "static/img/oops_zipcode.e633fd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oops_zipcode.png
// module id = X+Uz
// module chunks = 1